import { Theme, alpha } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { UiAlpha } from '../../../../styles/ui-alpha';

export const useStyles = makeStyles<Theme>()((theme) => ({
  planItem: {
    position: 'relative',
    flex: '1 1 0',
    minWidth: 0,
    padding: '24px 16px',
    margin: 0,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 10,
    border: `1px solid ${theme.palette.divider}`,
    boxSizing: 'border-box',
    height: 'max-content',
    transition: '0.2s',

    [theme.breakpoints.down('md')]: {
      flex: '0 0 auto',
      width: '100%',
    },
  },
  planItemActive: {
    backgroundColor: alpha(theme.palette.primary.main, UiAlpha.Tint),
    border: `1px solid ${theme.palette.primary.main}`,
  },
  saveMoneyWrapper: {
    position: 'absolute',
    top: theme.spacing(-1),
    right: theme.spacing(-2),
    zIndex: 1,
  },
  saveMoneyText: {
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.success.contrastText,
    padding: theme.spacing(0.25, 1),
    borderRadius: 10,
  },

  planHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  planIconBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 48,
    height: 48,
    borderRadius: 10,
    marginBottom: theme.spacing(1),
    backgroundColor: theme.palette.contentBackground.grey,
    color: theme.palette.primary.main,
  },
  planIconSvg: {
    width: 24,
    height: 24,
    display: 'block',
  },
  title: {
    ...theme.mixins.appEllipsis,
    margin: 0,
    textTransform: 'capitalize',
    maxWidth: '100%',
    textAlign: 'center',
    color: theme.palette.text.primary,
  },

  restrictionsWrapper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  restrictionRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
    textAlign: 'left',
    '&:last-child': {
      marginBottom: 0,
    },
  },
  restrictionCheck: {
    flexShrink: 0,
    marginTop: 2,
    color: theme.palette.text.secondary,
  },
  restrictionText: {
    color: theme.palette.text.secondary,
    textAlign: 'left',
    lineHeight: 1.35,
  },

  priceRow: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'baseline',
    justifyContent: 'center',
    gap: theme.spacing(0.25),
    margin: theme.spacing(2, 0, 3),
  },
  priceAmount: {
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightBold,
    fontSize: '1.75rem',
    lineHeight: 1.2,
  },
  pricePeriod: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    lineHeight: 1.25,
    fontWeight: 400,
  },

  bottom: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',

    '& .MuiButton-root': {
      width: '100%',
    },
  },
}));
